export type IconName =
  | 'calendar'
  | 'plane'
  | 'sheets'
  | 'notes'
  | 'cashflow'
  | 'investments'
  | 'stock'
  | 'payroll'
  | 'calculators'
  | 'home'
  | 'settings'
  | 'sun'
  | 'moon'
  | 'monitor'
  | 'devices'
  | 'smartphone'
  | 'menu'
  | 'moreMenu'
  | 'close'
  | 'user'
  | 'userPlus'
  | 'eye'
  | 'pencil'
  | 'chevronDown'
  | 'chevronRight'
  | 'mail'
  | 'folder'
  | 'folderPlus'
  | 'plus'
  | 'plusMinus'
  | 'more'
  | 'moreVertical'
  | 'trash'
  | 'restore'
  | 'star'
  | 'link'
  | 'move'
  | 'folderMove'
  | 'search'
  | 'grid'
  | 'apps'
  | 'clock'
  | 'users'
  | 'check'
  | 'building'
  | 'palette'
  | 'alignment'
  | 'alignLeft'
  | 'alignCenter'
  | 'alignRight'
  | 'alignAuto'
  | 'wrapText'
  | 'clipText'
  | 'shrinkText'
  | 'expandText'
  | 'overflowText'
  | 'copy'
  | 'save'
  | 'globe'
  | 'install'
  | 'arrowLeft'
  | 'sidebar'
  | 'bed'
  | 'utensils'
  | 'activity'
  | 'car'
  | 'bus'
  | 'train'
  | 'bold'
  | 'bot'
  | 'eyeOff'
  | 'alertCircle'
  | 'fileExport'
  | 'layout'
  | 'help';

/** Single-path 24×24 outline icons — no icon-library dependency. */
const PATHS: Record<IconName, string> = {
  bold: 'M6 4h8a4 4 0 0 1 4 4 4 4 0 0 1-4 4H6zM6 12h9a4 4 0 0 1 4 4 4 4 0 0 1-4 4H6z',
  bot: 'M12 8V4H8M16 4h-4M2 14h2M20 14h2M15 13v2M9 13v2M5 10a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-8Z',
  arrowLeft: 'M19 12H5M12 19l-7-7 7-7',
  eyeOff: 'M3 3l18 18M10.6 5.1A10 10 0 0 1 12 5c6.4 0 10 7 10 7a17 17 0 0 1-2.9 3.8M6.6 6.6C3.9 8.4 2 12 2 12s3.6 7 10 7a9.7 9.7 0 0 0 5.4-1.6M9.9 9.9a3 3 0 0 0 4.2 4.2',
  alertCircle: 'M12 8v4M12 16h.01M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z',
  fileExport: 'M14 3H6a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V8zM14 3v5h5M9 14h7M13 11l3 3-3 3',
  layout: 'M3 3h18v18H3zM3 15h18M9 15v6',
  sidebar: 'M4 4h16v16H4zM9 4v16',
  calendar:
    'M8 2v4M16 2v4M3 10h18M5 4h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2Z',
  plane: 'M3 11h7l4-8h3l-1 8h5a2 2 0 0 1 0 4h-5l1 8h-3l-4-8H3l-1-2 1-2Z',
  sheets: 'M3 3h18v18H3zM3 9h18M3 15h18M9 3v18M15 3v18',
  notes: 'M5 3h9l5 5v13H5zM14 3v5h5M8 13h8M8 17h5',
  cashflow: 'M3 17l6-6 4 4 8-8M15 7h6v6',
  investments:
    'M3 7h18v13H3zM8 7V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2M3 12h18',
  stock: 'M21 8l-9-5-9 5 9 5 9-5ZM3 12l9 5 9-5M3 16l9 5 9-5',
  payroll:
    'M12 7v10M9.5 9.5a2.5 2.5 0 0 1 2.5-2h1M14.5 14.5a2.5 2.5 0 0 1-2.5 2h-1M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z',
  calculators:
    'M6 3h12a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1ZM8 7h8M8 11h.01M12 11h.01M16 11h.01M8 15h.01M12 15h.01M16 15v2',
  home: 'M3 10l9-7 9 7v10a1 1 0 0 1-1 1h-5v-7H9v7H4a1 1 0 0 1-1-1Z',
  settings:
    'M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM19.4 15a1.6 1.6 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.6 1.6 0 0 0-1.8-.3 1.6 1.6 0 0 0-1 1.5V21a2 2 0 1 1-4 0v-.1a1.6 1.6 0 0 0-1-1.5 1.6 1.6 0 0 0-1.8.3l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.6 1.6 0 0 0 .3-1.8 1.6 1.6 0 0 0-1.5-1H3a2 2 0 1 1 0-4h.1a1.6 1.6 0 0 0 1.5-1 1.6 1.6 0 0 0-.3-1.8l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1.6 1.6 0 0 0 1.8.3H9a1.6 1.6 0 0 0 1-1.5V3a2 2 0 1 1 4 0v.1a1.6 1.6 0 0 0 1 1.5 1.6 1.6 0 0 0 1.8-.3l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.6 1.6 0 0 0-.3 1.8V9a1.6 1.6 0 0 0 1.5 1H21a2 2 0 1 1 0 4h-.1a1.6 1.6 0 0 0-1.5 1Z',
  help: 'M9.1 9a3 3 0 0 1 5.8 1c0 2-3 2.1-3 4M12 17h.01M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z',
  sun: 'M12 3v2M12 19v2M3 12h2M19 12h2M5.64 5.64l1.42 1.42M16.94 16.94l1.42 1.42M18.36 5.64l-1.42 1.42M7.06 16.94l-1.42 1.42M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z',
  moon: 'M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79Z',
  monitor: 'M4 4h16v12H4zM8 20h8M12 16v4',
  // Laptop with a phone beside it — "every device".
  devices: 'M18 8V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h8M10 19v-4M7 19h5M17 11h4a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-8a1 1 0 0 1 1-1Z',
  smartphone: 'M8 2h8a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2ZM12 18h.01',
  menu: 'M4 7h16M4 12h16M4 17h16',
  // Lines with a plus — the bottom bar's "More" button.
  moreMenu: 'M4 6.5h16M4 12h10M4 17.5h8M18 14.5v6M15 17.5h6',
  close: 'M6 6l12 12M18 6L6 18',
  user: 'M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2M12 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z',
  userPlus:
    'M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8ZM19 8v6M22 11h-6',
  eye: 'M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7-10-7-10-7ZM12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z',
  pencil: 'M12 20h9M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4Z',
  chevronDown: 'M6 9l6 6 6-6',
  chevronRight: 'M9 6l6 6-6 6',
  mail: 'M4 5h16a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1ZM3 7l9 6 9-6',
  folder: 'M3 7a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2Z',
  folderPlus:
    'M3 7a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2ZM12 11v6M9 14h6',
  plus: 'M12 5v14M5 12h14',
  // ± — a number column's sign rule.
  plusMinus: 'M12 4v10M7 9h10M7 19h10',
  // Three dots. Drawn as three degenerate segments so the shared single-path
  // renderer can carry it without a fill.
  more: 'M6 12h.01M12 12h.01M18 12h.01',
  moreVertical: 'M12 6h.01M12 12h.01M12 18h.01',
  // A 3×3 dot grid — the app launcher. Real circles, so render it `filled`.
  apps: 'M4.5 6a1.5 1.5 0 1 0 3 0a1.5 1.5 0 1 0 -3 0M10.5 6a1.5 1.5 0 1 0 3 0a1.5 1.5 0 1 0 -3 0M16.5 6a1.5 1.5 0 1 0 3 0a1.5 1.5 0 1 0 -3 0M4.5 12a1.5 1.5 0 1 0 3 0a1.5 1.5 0 1 0 -3 0M10.5 12a1.5 1.5 0 1 0 3 0a1.5 1.5 0 1 0 -3 0M16.5 12a1.5 1.5 0 1 0 3 0a1.5 1.5 0 1 0 -3 0M4.5 18a1.5 1.5 0 1 0 3 0a1.5 1.5 0 1 0 -3 0M10.5 18a1.5 1.5 0 1 0 3 0a1.5 1.5 0 1 0 -3 0M16.5 18a1.5 1.5 0 1 0 3 0a1.5 1.5 0 1 0 -3 0',
  trash: 'M4 7h16M10 11v6M14 11v6M6 7l1 13a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1l1-13M9 7V4h6v3',
  restore: 'M3 12a9 9 0 1 0 3-6.7M3 4v5h5',
  star: 'M12 3.5l2.6 5.3 5.9.9-4.2 4.1 1 5.8-5.3-2.8-5.3 2.8 1-5.8L3.5 9.7l5.9-.9Z',
  link: 'M10 13a5 5 0 0 0 7.5.5l2-2a5 5 0 0 0-7-7l-1 1M14 11a5 5 0 0 0-7.5-.5l-2 2a5 5 0 0 0 7 7l1-1',
  // A folder with an arrow into it: moving a file, not dragging a thing.
  folderMove: 'M3 7a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2ZM8 13.5h7M12.5 10.5l3 3-3 3',
  move: 'M12 3v18M3 12h18M12 3l-3 3M12 3l3 3M12 21l-3-3M12 21l3-3M3 12l3-3M3 12l3 3M21 12l-3-3M21 12l-3 3',
  search: 'M11 18a7 7 0 1 0 0-14 7 7 0 0 0 0 14ZM20 20l-4-4',
  check: 'M5 13l4 4L19 7',
  clock: 'M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18ZM12 7v5l3 2',
  users: 'M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8ZM22 21v-2a4 4 0 0 0-3-3.9M16 3.1a4 4 0 0 1 0 7.8',
  // Four rounded squares: the cards half of a list/cards switch.
  grid: 'M5 4h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1ZM15 4h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1ZM5 14h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1ZM15 14h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1Z',
  building:
    'M4 21V5a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v16M14 9h4a2 2 0 0 1 2 2v10M8 7h2M8 11h2M8 15h2M3 21h18',
  palette:
    'M12 3.5a8.5 8.5 0 1 0 0 17c1.1 0 1.7-.8 1.7-1.6 0-1.4 1-2 2.2-2H18a3 3 0 0 0 3-3c0-5.3-4-10.4-9-10.4ZM8 11h.01M12 8h.01M16 11h.01',
  alignment: 'M4 6h16M4 10h10M4 14h16M4 18h10',
  alignLeft: 'M4 6h16M4 12h10M4 18h14',
  alignCenter: 'M4 6h16M7 12h10M5 18h14',
  alignRight: 'M4 6h16M10 12h10M6 18h14',
  alignAuto: 'M3 5h18M3 19h18M7 15l5-10 5 10M8.8 12h6.4',
  wrapText: 'M4 6h16M4 12h11a3 3 0 0 1 0 6h-4M14 15l-3 3 3 3M4 18h4',
  clipText: 'M3 6h18M3 12h11M17 12h.01M20 12h.01M3 18h18',
  shrinkText: 'M4 6h16M3 12h4m10 0h4M9 12l-2-2m2 2l-2 2M15 12l2-2m-2 2l2 2M4 18h16',
  expandText: 'M3 6v12M21 6v12M6 12h12M8 10l-2 2 2 2M16 10l2 2-2 2',
  overflowText: 'M4 6v12M8 12h12M16 8l4 4-4 4',
  copy: 'M9 9h10v11H9zM5 5h10v11M5 5v11h4',
  save: 'M5 3h12l3 3v15H5zM8 3v6h8V3M8 20v-7h8v7',
  globe:
    'M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2Zm0 0c2.5 2.7 4 6.2 4 10s-1.5 7.3-4 10c-2.5-2.7-4-6.2-4-10S9.5 4.7 12 2ZM2.5 9h19M2.5 15h19',
  install: 'M12 3v11M8 10l4 4 4-4M5 18v2a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2',
  bed: 'M3 19v-7a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v7M3 19v2M21 19v2M3 15h18M7 10V6a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v3',
  utensils:
    'M6 2v8a2 2 0 0 0 4 0V2M8 10v12M16 2v7a2 2 0 0 0 2 2v0a2 2 0 0 0 2-2V2M18 11v11',
  activity: 'M12 3.5a8.5 8.5 0 1 0 0 17 8.5 8.5 0 0 0 0-17ZM15 9l-4 4-2-1-2.5 3.5',
  car: 'M4 17h16M5 17l1.5-6a2 2 0 0 1 2-1.5h7a2 2 0 0 1 2 1.5L19 17M4 17v2a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-2M17 17v2a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-2M7 13.5h10',
  bus: 'M4 16V6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v10M4 16h16M4 16v2a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1M18 18v-1a1 1 0 0 1 1-1h1M6 9h12',
  train:
    'M6 3h12a2 2 0 0 1 2 2v9a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V5a2 2 0 0 1 2-2ZM4 17l-2 4M20 17l2 4M8 8h8M9 14h.01M15 14h.01',
};

interface Props {
  name: IconName;
  className?: string;
  /** Paint the shape as well as its outline. A star means something different
   *  full than empty, and that distinction has to survive at 16px. */
  filled?: boolean;
}

export function Icon({ name, className = 'h-5 w-5', filled = false }: Props) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill={filled ? 'currentColor' : 'none'}
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
      focusable="false"
    >
      <path d={PATHS[name]} />
    </svg>
  );
}
